import { pgTable, primaryKey, text } from "drizzle-orm/pg-core";

export const language = pgTable("language", {
  code: text("code").primaryKey(),
});

export const locale = pgTable(
  "locale",
  {
    language: text("language")
      .notNull()
      .references(() => language.code),
    region: text("region").notNull(),
  },
  (t) => [primaryKey({ name: "locale_pk", columns: [t.language, t.region] })],
);
